
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.625 0v1H0v2h1.125v13a2.136 2.136 0 002.25 2h11.25a2.136 2.136 0 002.25-2V3H18V1h-5.625V0h-6.75m-2.25 3h11.25v13H3.375V3m2.25 2v9h2.25V5h-2.25m4.5 0v9h2.25V5z","fill":"#fff"}})])
          )
        }
      }
    